import { Grid, Typography } from "@mui/material";
import React from "react";
import EmptyClipListSvg from "../../../../SvgIcons/EmptyClipListSvg";

interface OwnProps {}

type Props = OwnProps;

const EmptyClipList: React.FC<Props> = (props) => {
    return (
        <Grid
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            style={{ position: "relative", top: "51px" }}
        >
            <Grid
                item
                sx={{
                    position: "relative",
                    borderRadius: "50%",
                    height: "124px",
                    width: "124px",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: "68%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    <EmptyClipListSvg />
                </div>
            </Grid>
            <Grid item style={{ marginTop: "32px" }}>
                <Typography
                    sx={{
                        color: "#1F1F1F",
                        opacity: 0.25,
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: "bold",
                        letterSpacing: 0,
                        lineHeight: "20px",
                        textAlign: "center",
                    }}
                    variant={"body2"}
                >
                    You haven't created any quotes
                </Typography>
            </Grid>
        </Grid>
    );
};

export default EmptyClipList;
